import React from "react"
import {defineMessages, FormattedMessage} from "react-intl"
import {Link} from "react-router-dom"

type Props = {
    children: React.ReactNode
    links: string[]
}

const messages = defineMessages({
    signin: {
        id: "login.forgot_password.signin_label",
        defaultMessage: "Back to Login",
    },
    signup: {
        id: "login.forgot_password.signup_label",
        defaultMessage: "You don't have an account yet?",
    },
})

const LoginSection = (props: Props) => {
    return (
        <div className="row ui-has-modules justify-content-md-center">
            <div className="col-12 my-4">
                <h1 className="text-align-center">
                    <img src='/images/QuoteM_regular.png' height='80px'/>
                </h1>
            </div>

            <div className="col-md-6 col-lg-5 col-xl-4 ui-module">
                {props.children}
            </div>

            {props.links.map((link, i) => {
                return (
                    <div key={i} className="col-12">
                        <p className="text-align-center">
                            <Link to={`/p/${link}`}>
                                <FormattedMessage {...messages[link]}/>
                            </Link>
                        </p>
                    </div>
                )
            }
            )}
        </div>
    )
}


export default LoginSection


// WEBPACK FOOTER //
// ./src/auth/sections/LoginSection.tsx